import { number, object } from 'zod';

import { IS_POSITIVE, IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

import { CountProductsBySchema } from '../count-products-by/count-products-by.validation';
import { ProductGroupsSchema } from '../product-groups/product-groups.validation';

export const ProductPurchaseSchema = object({
  purchaseThreshold: number({ required_error: IS_REQUIRED }).gt(0, { message: IS_POSITIVE }),
  countProductsBy: CountProductsBySchema,
  eligibleProductGroups: ProductGroupsSchema,
});
